import { useEffect, useState } from "react";
import CtaButton from "./CtaButton";
import { useVariant } from "../context/VariantContext";

export default function FloatingNav() {
  const { ctaBadge, ctaText, ctaHref } = useVariant();
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setShowTop(window.scrollY > 400);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="lp__floating lp__floating--visible">
      <CtaButton href={ctaHref} badge={ctaBadge} text={ctaText} trackLocation="floating" />
      <button
        className={`lp__floating-top${showTop ? " lp__floating-top--visible" : ""}`}
        onClick={scrollToTop}
        aria-label="トップへ戻る"
      >
        ↑
      </button>
    </div>
  );
}
